module.exports = __webpack_public_path__ + "media/images/landing_page/screen_pc_mobile-7e814172a5aaacc32dc26d2e8d4686df.webp";